import {
  textColor,
  themeByColor,
  themeByTextColor,
} from "../../utils/ColorUtils.js";
import { RequestService } from "../../services/request.service";
const requestService = new RequestService();

const state = {
  theme: {
    textColor: null,
    theme: null,
    themeOnPrimary: null,
    themeOnSecondary: null,
  },
  customization: null,
};

const getters = {
  textColor: (state) => state.theme.textColor,
  theme: (state) => state.theme.theme,
  themeOnPrimary: (state) => state.theme.themeOnPrimary,
  themeOnSecondary: (state) => state.theme.themeOnSecondary,
  customization: (state) => state.customization,
};

const actions = {
  getCustomization: ({ state, dispatch }, { context, getSaved }) => {
    if (state.customization && getSaved) {
      return state.customization;
    } else {
      const savedCustomization =
        localStorage.getItem("customization") != null
          ? JSON.parse(localStorage.getItem("customization"))
          : null;
      if (savedCustomization && getSaved) {
        dispatch("setCustomization", { context, savedCustomization });
        return savedCustomization;
      } else if (context.$store.getters.instanceId) {
        return requestService.getCustomization(context);
      } else {
        return null;
      }
    }
  },
  setCustomization: (
    { state, commit, dispatch },
    { context, customization }
  ) => {
    state.customization = customization;
    state.customization.economics.currency_symbol =
      customization.economics.currency.toUpperCase() === "EUR"
        ? "euro_symbol"
        : "attach_money";
    localStorage.setItem("customization", JSON.stringify(customization));
    context.$vuetify.theme.themes.light.primary = customization.colors.primary;
    context.$vuetify.theme.themes.light.secondary =
      customization.colors.secondary;
    context.$vuetify.theme.themes.light.textOverPrimary =
      customization.colors.primary_text;
    context.$vuetify.theme.themes.light.textOverSecondary =
      customization.colors.secondary_text;
    var metas = document.getElementsByClassName("primaryColorMeta");
    for (var i = 0; i < metas.length; ++i) {
      var element = metas[i];
      element.setAttribute("content", customization.colors.primary);
    }
    commit("setTheme", context);
    dispatch("setFavicon");
  },
  setFavicon: ({ state }) => {
    var link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = state.customization.favicon;
    document.getElementsByTagName("head")[0].appendChild(link);
    document.title = state.customization.title;
  },
  getPaymentData: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.economics);
        })
        .catch((error) => reject(error));
    });
  },
  getCurrency: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.economics.currency);
        })
        .catch((error) => reject(error));
    });
  },
  getLogo: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.logo);
        })
        .catch((error) => reject(error));
    });
  },
  getEventName: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.name);
        })
        .catch((error) => reject(error));
    });
  },
  getEconomics: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.economics);
        })
        .catch((error) => reject(error));
    });
  },
  getLegalNotice: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.legal);
        })
        .catch((error) => reject(error));
    });
  },
  getCategories: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.categories);
        })
        .catch((error) => reject(error));
    });
  },
  getEditProfile: ({ dispatch }, context) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: true })
        .then((customization) => {
          resolve(customization.allow_profile_editing);
        })
        .catch((error) => reject(error));
    });
  },
};

const mutations = {
  setTheme: (state, context) => {
    state.theme.theme = themeByColor(
      context.$vuetify.theme.themes.light.primary
    );
    state.theme.textColor = textColor(
      context.$vuetify.theme.themes.light.primary
    );
    state.theme.themeOnPrimary = themeByTextColor(
      context.$vuetify.theme.themes.light.textOverPrimary
    );
    state.theme.themeOnSecondary = themeByTextColor(
      context.$vuetify.theme.themes.light.textOverSecondary
    );
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
